import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { keyframes } from '@emotion/react'
import { mediaQuery } from '@lacedltd/laced-components'
import { StyledModalProps, AlignProps } from './Modal.types'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeInDrop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const drawerAnimation = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`

const getAlignmentStyles = (align: AlignProps) => {
  switch (align) {
    case 'top':
      return 'flex-start;'
    case 'bottom':
      return 'flex-end;'
    case 'center':
    default:
      return 'center;'
  }
}

export const ModalBackdrop = styled.div({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.5)',
  opacity: 0,
  animation: `${fadeIn} 250ms forwards`,
  display: 'flex',
  zIndex: 99
})

export const ModalContent = styled.div({
  maxHeight: '100vh',
  animation: `${fadeInDrop} 250ms forwards`,
  background: tokens.color.yeezy[0],
  padding: tokens.spacing[7],
  opacity: 0
})

export const ModalError = styled.span({
  width: '100%'
})

export const ModalClose = styled.button({
  position: 'absolute',
  top: tokens.spacing[5],
  right: tokens.spacing[5],
  cursor: 'pointer'
})

export const ModalActionContainer = styled.div<{ equal?: boolean }>(
  ({ equal = false }) => ({
    display: 'flex',
    marginTop: tokens.spacing[6],
    gap: tokens.spacing[6],

    '*': {
      flexGrow: 1,
      flexBasis: equal ? 0 : 1
    }
  })
)

export const StyledModal = styled.div<StyledModalProps>(
  ({
    width = 'auto',
    align = 'center',
    justify = 'center',
    drawer = false,
    scrollContainer = false
  }) => ({
    [`${ModalContent}`]: {
      width: `${width}px`,
      overflow: `${scrollContainer ? 'auto' : 'visible'}`
    },

    [`${ModalBackdrop}`]: {
      alignItems: getAlignmentStyles(align),
      justifyContent: justify
    },

    [mediaQuery.m.max]: {
      [`${ModalContent}`]: {
        animation: `${drawerAnimation} 250ms forwards`,
        borderRadius: `${tokens.spacing[3]} ${tokens.spacing[3]} 0 0`,
        width: '100%',
        opacity: 1
      },

      [`${ModalBackdrop}`]: {
        alignItems: drawer ? 'flex-end' : getAlignmentStyles(align)
      },

      [`${ModalActionContainer}`]: {
        flexDirection: 'column-reverse'
      }
    }
  })
)
